import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    height: 100%;
  }

  .buttons-section {
    display: flex;
    justify-content: flex-end;
    gap: var(--sds-size-space-400); /* 16px */
    flex-shrink: 0;
    margin-bottom: var(--sds-size-space-600); /* 24px */
  }

  .links-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .links-content-empty {
    justify-content: center;
    align-items: center;
  }

  .links-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--sds-size-space-400); /* 16px */
    width: 100%;
    justify-content: center;
  }

  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: var(--sds-size-space-600); /* 24px */
  }

  .empty-state-title {
    color: var(--sds-color-text-default-default);
    text-align: center;
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-subheading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.5;
    margin: 0;
  }

  .empty-state-subtitle {
    color: var(--sds-color-text-default-secondary);
    text-align: center;
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
    margin: 0;
  }

  .delete-confirmation-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  /* Drop indicator styles */
  .drop-indicator {
    position: absolute;
    background: #007bff;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 0 8px #007bff;
  }

  .drop-indicator.horizontal {
    height: 4px;
    width: 100%;
    border-radius: 2px;
    margin-left: 0;
  }

  .drop-indicator.vertical {
    width: 4px;
    height: 100%;
    border-radius: 2px;
    margin-top: 0;
  }

  .drop-indicator.active {
    opacity: 1;
    background: var(--sds-color-accent-brand-default, #007bff);
  }

  /* Drag state styles */
  .links-grid.drag-active {
    position: relative;
  }

  .links-grid.drag-active link-card.dragging {
    opacity: 0.5;
    transform: scale(0.95);
    transition:
      opacity 0.2s ease,
      transform 0.2s ease;
  }

  .scrollable-column-content {
    flex: 1 0 0;
  }

  .containers {
    display: flex;
    flex-direction: row;
    gap: var(--sds-size-space-600);
    width: 100%;
    height: 100%;
  }

  /* Enhanced drag handle */

  /* Prevent text selection during drag */
  .links-grid.drag-active {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  /* Skeleton loading styles */
  .skeleton-rectangle {
    box-sizing: border-box;
    grid-column: span 2;
    border-radius: var(--sds-size-radius-400);
    padding: 12px 16px 12px 8px;
  }

  .skeleton-square {
    box-sizing: border-box;
    padding: 12px 8px;
    grid-column: span 1;
    aspect-ratio: 1;
    border-radius: var(--sds-size-radius-400);
  }

  /* Tabs container */
  .tabs-container {
    display: flex;
    gap: var(--sds-size-space-400);
    margin-bottom: var(--sds-size-space-600);
  }

  .links-filter {
    margin-bottom: var(--sds-size-space-400);
  }
`;
